const BASE_PATH = 'VENDOR_OTHER_INFO';

export const SET_OTHER_INFO_DATA = `${BASE_PATH}/SET_OTHER_INFO_DATA`;
export const VALIDATE_OTHER_INFO_DATA = `${BASE_PATH}/VALIDATE_OTHER_INFO_DATA`;
export const CLEAR_INFO_DATA = `${BASE_PATH}/CLEAR_INFO_DATA`;

export const setOtherInfoData = data => ({
    type: SET_OTHER_INFO_DATA,
    data
});

export const validateOtherInfoData = () => ({
    type: VALIDATE_OTHER_INFO_DATA,
});

export const clearOtherInfoData = () => ({
    type: CLEAR_INFO_DATA,
});

const initialState = {
    workExperienceIn: [],
    workLocations: [],
    balanceCapacity: "",
    turnover: "",
    experience: "",
    generalType: "",
    additionalInfo: "",

    balanceCapacityError: "",
    turnoverError: "",
    experienceError: "",
    generalTypeError: "",
    workExperienceInError: '',
    workLocationsError: '',
    additionalInfoError: "",
    
    validate: false,
    isValid: false
}

export default function reducer(state = { ...initialState }, action) {
    switch (action.type) {
        case SET_OTHER_INFO_DATA:
            let newState = { ...state };
            action.data.forEach(data => {
                newState[data.key] = Array.isArray(data.value) ? [...data.value] : data.value;
            });
            return newState;

        case VALIDATE_OTHER_INFO_DATA:
            return { ...state, validate: true }
        case CLEAR_INFO_DATA:
            return { ...initialState }
    }

    return state;
}